// extracted by mini-css-extract-plugin
export var searchHeader = "_7n-0";
export var searchHeaderDark = "_7n-1";